import axios from "axios"
import Vue from "vue"
import store from "../../store"
import {
    generateQueryString,
    headersWithToken,
    domain
} from '../../service/configApi'

//#region guardian
export const formKey = "kct-tp";
// export const courseId = "60878cba7f0bed471ca2ab34" // dev
// export const courseId = "608b6f806a4a0864ca111e5f" // prod
export const companyWhiteList = ["6086ac5bc8ad211716065bad", "608b7c756a4a0864ca1143be", "5f3b5147a48c4d52a612d625"]

export const checkCompany = () => {
    return getFormByKey(formKey).then((form) => {
        if (form == null) return false
        else return true
    })
}

export const viewGuard = () => {
    if (store.state.company != null && store.state.company._id != null) {
        return checkCompany().then(val => {
            return val
        })
    } else {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(false)
            });
        })
    }
}
//#endregion

//#region pattern and group data (rank)
export const groupKeys = {
    Riser: "RISER",
    Settler: "SETTLER",
    Wanderluster: "WANDERLUSTER",
    Neophyte: "NEOPHYTE"
}

export const ranks = [
    {
        text: groupKeys.Riser,
        value: groupKeys.Riser,
    },
    {
        text: groupKeys.Settler,
        value: groupKeys.Settler,
    },
    {
        text: groupKeys.Wanderluster,
        value: groupKeys.Wanderluster,
    },
    {
        text: groupKeys.Neophyte,
        value: groupKeys.Neophyte,
    },
]

export const patterns = [
    {
        key: "HHHH",
        group: groupKeys.Riser,
        factors: [1, 1, 0, 0, 0],
        desc: `การฝึกอบรมด้านผู้นำในองค์กร`
    },
    {
        key: "HHHL",
        group: groupKeys.Settler,
        factors: [0, 0, 1, 0, 0],
        desc: `การฝึกอบรมด้านการจูงใจตนเองให้เติบโต`
    },
    {
        key: "HHLH",
        group: groupKeys.Wanderluster,
        factors: [0, 0, 0, 0, 1],
        desc: `การฝึกอบรมด้านการรับมือกับแรงกดดัน`
    },
    {
        key: "HHLL",
        group: groupKeys.Neophyte,
        factors: [0, 0, 1, 0, 1],
        desc: `การฝึกอบรมด้านการรับมือกับแรงกดดันและการจูงใจตนเองให้เติบโต`
    },
    {
        key: "HLHH",
        group: groupKeys.Riser,
        factors: [0, 1, 0, 0, 0],
        desc: `การฝึกอบรมด้านการทำงานร่วมกับผู้อื่น`
    },
    {
        key: "HLHL",
        group: groupKeys.Settler,
        factors: [0, 1, 1, 0, 0],
        desc: `การฝึกอบรมด้านการการทำงานร่วมกับผู้อื่นและการจูงใจตนเองให้เติบโต`
    },
    {
        key: "HLLH",
        group: groupKeys.Wanderluster,
        factors: [0, 1, 0, 0, 1],
        desc: `การฝึกอบรมด้านการการทำงานร่วมกับผู้อื่นรับมือและการรับมือกับแรงกดดัน`
    },
    {
        key: "HLLL",
        group: groupKeys.Neophyte,
        factors: [0, 1, 1, 0, 1],
        desc: `การฝึกอบรมด้านการรับมือกับแรงกดดัน การจูงใจตนเองให้เติบโต และการทำงานร่วมกับผู้อื่น`
    },
    {
        key: "LHHH",
        group: groupKeys.Riser,
        factors: [0, 0, 0, 1, 0],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์`
    },
    {
        key: "LHHL",
        group: groupKeys.Settler,
        factors: [0, 0, 1, 1, 0],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์และการจูงใจตนเองให้เติบโต`
    },
    {
        key: "LHLH",
        group: groupKeys.Wanderluster,
        factors: [0, 0, 0, 1, 1],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์และการรับมือกับแรงกดดัน`
    },
    {
        key: "LHLL",
        group: groupKeys.Neophyte,
        factors: [0, 0, 1, 1, 1],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์  การทำงานร่วมกับผู้อื่น การรับมือกับแรงกดดัน`
    },
    {
        key: "LLHH",
        group: groupKeys.Riser,
        factors: [0, 1, 0, 1, 0],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์และการทำงานร่วมกับผู้อื่น`
    },
    {
        key: "LLHL",
        group: groupKeys.Settler,
        factors: [0, 1, 1, 1, 0],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์  การทำงานร่วมกับผู้อื่น การจูงใจตนเองให้เติบโต`
    },
    {
        key: "LLLH",
        group: groupKeys.Wanderluster,
        factors: [0, 0, 1, 1, 1],
        desc: `การฝึกอบรมด้านความคิดสร้างสรรค์  การทำงานร่วมกับผู้อื่น การรับมือกับแรงกดดัน`
    },
    {
        key: "LLLL",
        group: groupKeys.Neophyte,
        factors: [0, 1, 1, 1, 1],
        desc: `ทุกด้าน`
    },
]
//#endregion

//#region data 
export const headers = [
    { text: 'USERNAME', sortable: false, value: 'userDetail.username', divider: true, width: 160 },
    {
        text: 'NAME',
        align: 'start',
        sortable: false,
        value: 'name',
        divider: true,
        width: 240
    },
    { text: 'GENDER', sortable: false, value: 'userDetail.gender', divider: true, width: 100, align: 'center' },
    { text: 'RANK', sortable: false, value: 'rank', divider: true, width: 150 },
    { text: 'TRAINING NEEDS', sortable: false, value: 'report.myPattern.desc', },
    // { text: 'DATE', sortable: false, value: 'finishDate' }
]

export const getListOfUser = (filter) => {
    let qs = generateQueryString(filter)
    let config = { headers: headersWithToken() }
    return axios.get(`${domain}/evaluate/assessor?${qs}`, config)
}

export const getDefaultForm = () => {
    let config = { headers: headersWithToken() }
    return axios.get(`${domain}/evaluate/form/default`, config).then((resp) => {
        return resp.data
    }).catch(() => {
        return null
    })
}

export const getFormByKey = (key) => {
    let config = { headers: headersWithToken() }
    return axios.get(`${domain}/evaluate/form/key/${key}`, config).then((resp) => {
        return resp.data
    }).catch(() => {
        return null
    })
}
export const getOverview = () => {
    let config = { headers: headersWithToken() }
    return axios.get(`${domain}/evaluate/overview`, config).then((resp) => {
        // fix data to ready to use
        if (resp.data != null && resp.data.rank != null) {
            let dataRanks = ranks.map(a => Object.assign({}, a))
            let sortRanks = []
            for (const rank of dataRanks) {
                // find rank in rank response
                let rankObj = resp.data.rank.ranks.find(x => x._id == rank.value)
                if (rankObj == null) {
                    rankObj = {
                        _id: rank.value,
                        total: 0,
                        percentage: 0,
                    }
                    sortRanks.push(rankObj)
                } else {
                    rankObj.percentage = ((100 * rankObj.total) / resp.data.rank.totalAssessor).toFixed(2)
                    sortRanks.push(rankObj)
                }
            }

            resp.data.rank.ranks = sortRanks
        }

        return resp.data
    }).catch(() => {
        return null
    })
}

export const getDownloadLink = () => {
    let config = { headers: headersWithToken(), responseType: 'blob' }
    config.headers.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    return axios.get(`${domain}/evaluate/assessor/download?company=${store.state.company._id}`, config)
}

//#endregion

export default { checkCompany, viewGuard, getListOfUser, getDefaultForm, getFormByKey, getOverview, getDownloadLink }